import '/app/brewery-packages/content/content-editor-plugin-quote/src/Quote.css-raw';
export default {
  "icon": "about-us-b998e096-icon-D9SRnq",
  "quote": "about-us-b998e096-quote-D9SRnq"
};